import {
  getterNames,
  API_ACCOUNT_CLUSTERS,
  API_ACCOUNT_BRANDS,
  API_ACCOUNT_CLUSTER,
  API_ACCOUNT_CLUSTER_CREATE,
  API_ACCOUNT_BRAND_CREATE,
  API_ACCOUNT_CLUSTER_UPDATE,
  API_ACCOUNT_CLUSTER_PROPERTIES,
  API_ACCOUNT_CLUSTER_PROPERTY_ADD,
  API_ACCOUNT_CLUSTER_REMOVE,
  API_ACCOUNT_CLUSTER_PROPERTY_DELETE,
  API_ACCOUNT_CLUSTER_PROPERTY_TRANSFER,
  API_GET_ACCOUNT_PROPERTIES_NOBRAND,
  API_ACCOUNT_PROPERTIES,
} from './types';

import { buildApiRequest } from '@/modules/Vuex';

import apiClient from '@/modules/ApiClient';
import {
  accountClusters as ApiAccountClusters,
  accountBrands as ApiAccountBrands,
  accountClusterDetails as ApiAccountClusterDetails,
  accountClusterProperties as ApiAccountClusterProperties,
  accountClusterUpdate as ApiAccountClusterUpdate,
  accountClusterCreate as ApiAccountClusterCreate,
  accountBrandCreate as ApiAccountBrandCreate,
  accountClusterPropertyAdd as ApiAccountClusterPropertyAdd,
  accountClusterDelete as ApiAccountClusterDelete,
  accountClusterPropertyDelete as ApiAccountClusterPropertyDelete,
  accountClusterPropertyTransfer as ApiAccountClusterPropertyTransfer,
  accountClusterPropertiesNoBrand as ApiAccountClusterPropertiesNoBrand,
  accountProperties as ApiAccountProperties,
} from '@/api/routes/clusters';

const state = {
  isFetching: false,
  isFetchingProperties: false,
  isFetchingAvailableProperties: false,
  clusters: [],
  cluster: {},
  properties: [],
  availableProperties: [],
};

const getters = {
  [getterNames.CLUSTERS_GET_ACCOUNT_PROPERTIES_NOBRAND]:
  state => state.get_account_properties_nobrand?.isFetching,
};

const mutations = {
  [API_ACCOUNT_CLUSTERS.REQUEST](state) {
    state.error = null;
    state.isFetching = true;
  },
  [API_ACCOUNT_CLUSTERS.SUCCESS](state, data) {
    state.clusters = data;
    state.error = null;
    state.isFetching = false;
  },
  [API_ACCOUNT_CLUSTERS.ERROR](state, error) {
    state.error = error;
    state.isFetching = false;
  },

  [API_ACCOUNT_BRANDS.REQUEST](state) {
    state.error = null;
    state.isFetching = true;
  },
  [API_ACCOUNT_BRANDS.SUCCESS](state, data) {
    state.clusters = data;
    state.error = null;
    state.isFetching = false;
  },
  [API_ACCOUNT_BRANDS.ERROR](state, error) {
    state.error = error;
    state.isFetching = false;
  },

  [API_ACCOUNT_CLUSTER.REQUEST](state) {
    state.cluster = {};
    state.properties = { data: [] };
    state.error = null;
    state.isFetching = true;
  },
  [API_ACCOUNT_CLUSTER.SUCCESS](state, cluster) {
    state.cluster = {
      id: cluster.id,
      name: cluster.name,
      color: cluster.color,
      propertyCount: cluster.active_properties_count,
      properties: cluster.properties,
      type: cluster.type,
      logo: cluster.logo,
    };
    state.error = null;
    state.isFetching = false;
  },
  [API_ACCOUNT_CLUSTER.ERROR](state, error) {
    state.error = error;
    state.isFetching = false;
  },

  [API_ACCOUNT_CLUSTER_CREATE.REQUEST](state) {
    state.error = null;
  },
  [API_ACCOUNT_CLUSTER_CREATE.SUCCESS](state) {
    state.error = null;
  },
  [API_ACCOUNT_CLUSTER_CREATE.ERROR](state, error) {
    state.error = error;
  },

  [API_ACCOUNT_BRAND_CREATE.REQUEST](state) {
    state.error = null;
  },
  [API_ACCOUNT_BRAND_CREATE.SUCCESS](state) {
    state.error = null;
  },
  [API_ACCOUNT_BRAND_CREATE.ERROR](state, error) {
    state.error = error;
  },

  [API_ACCOUNT_CLUSTER_UPDATE.REQUEST](state) {
    state.error = null;
  },
  [API_ACCOUNT_CLUSTER_UPDATE.SUCCESS](state) {
    state.error = null;
  },
  [API_ACCOUNT_CLUSTER_UPDATE.ERROR](state, error) {
    state.error = error;
  },

  [API_ACCOUNT_CLUSTER_PROPERTIES.REQUEST](state) {
    state.error = null;
    state.isFetchingProperties = true;
  },
  [API_ACCOUNT_CLUSTER_PROPERTIES.SUCCESS](state, properties) {
    state.error = null;
    state.isFetchingProperties = false;
    state.properties = properties;
  },
  [API_ACCOUNT_CLUSTER_PROPERTIES.ERROR](state, error) {
    state.error = error;
    state.isFetchingProperties = false;
  },

  [API_ACCOUNT_CLUSTER_REMOVE.REQUEST](state) {
    state.error = null;
    state.isFetching = true;
  },
  [API_ACCOUNT_CLUSTER_REMOVE.SUCCESS](state) {
    state.error = null;
    state.isFetching = false;
  },
  [API_ACCOUNT_CLUSTER_REMOVE.ERROR](state, error) {
    state.error = error;
    state.isFetching = false;
  },

  [API_ACCOUNT_CLUSTER_PROPERTY_ADD.SUCCESS](state) {
    state.error = null;
  },

  [API_ACCOUNT_CLUSTER_PROPERTY_ADD.ERROR](state, error) {
    state.error = error;
  },

  [API_ACCOUNT_CLUSTER_PROPERTY_DELETE.SUCCESS](state) {
    state.error = null;
  },

  [API_ACCOUNT_CLUSTER_PROPERTY_DELETE.ERROR](state, error) {
    state.error = error;
  },

  [API_ACCOUNT_CLUSTER_PROPERTY_TRANSFER.REQUEST](state) {
    state.error = null;
  },
  [API_ACCOUNT_CLUSTER_PROPERTY_TRANSFER.SUCCESS](state) {
    state.error = null;
  },
  [API_ACCOUNT_CLUSTER_PROPERTY_TRANSFER.ERROR](state, error) {
    state.error = error;
  },

  [API_ACCOUNT_PROPERTIES.REQUEST](state) {
    state.error = null;
    state.isFetchingAvailableProperties = true;
    state.availableProperties = [];
  },
  [API_ACCOUNT_PROPERTIES.SUCCESS](state, properties) {
    state.error = null;
    state.isFetchingAvailableProperties = false;
    state.availableProperties = properties;
  },
  [API_ACCOUNT_PROPERTIES.ERROR](state, error) {
    state.isFetchingAvailableProperties = false;
    state.error = error;
  },
};

const actions = {
  async [API_ACCOUNT_CLUSTERS.REQUEST]({ commit }, {
    account,
    resultsPerPage = 10,
    pageNumber = 1,
    filterString = '',
  }) {
    try {
      commit(API_ACCOUNT_CLUSTERS.REQUEST);

      const { data } = await apiClient.request({
        method: 'GET',
        url: ApiAccountClusters,
        pathParams: {
          account: account.id,
        },
        params: {
          per_page: resultsPerPage,
          page_num: pageNumber,
          filters: [
            {
              field: 'name',
              operator: 'like',
              value: filterString,
            },
          ],
        },
      });

      if (!data) {
        throw new Error('no data returned');
      }

      commit(API_ACCOUNT_CLUSTERS.SUCCESS, data);
    } catch (error) {
      commit(API_ACCOUNT_CLUSTERS.ERROR, error);
    }
  },
  async [API_ACCOUNT_BRANDS.REQUEST]({ commit }, {
    account,
    resultsPerPage = 10,
    pageNumber = 1,
    filterString = '',
  }) {
    try {
      commit(API_ACCOUNT_BRANDS.REQUEST);

      const { data } = await apiClient.request({
        method: 'GET',
        url: ApiAccountBrands,
        pathParams: {
          account: account.id,
        },
        params: {
          per_page: resultsPerPage,
          page_num: pageNumber,
          filters: [
            {
              field: 'name',
              operator: 'like',
              value: filterString,
            },
          ],
        },
      });

      if (!data) {
        throw new Error('no data returned');
      }

      commit(API_ACCOUNT_BRANDS.SUCCESS, data);
    } catch (error) {
      commit(API_ACCOUNT_BRANDS.ERROR, error);
    }
  },
  async [API_ACCOUNT_CLUSTER.REQUEST]({ commit }, { account, cluster }) {
    try {
      commit(API_ACCOUNT_CLUSTER.REQUEST);

      const { data: clusterData } = await apiClient.request({
        method: 'GET',
        url: ApiAccountClusterDetails,
        pathParams: {
          id: account.id,
          cluster,
        },
      });

      if (!clusterData) {
        throw new Error('no data returned');
      }

      commit(API_ACCOUNT_CLUSTER.SUCCESS, clusterData);
    } catch (error) {
      commit(API_ACCOUNT_CLUSTER.ERROR, error);
    }
  },
  async [API_ACCOUNT_CLUSTER_PROPERTIES.REQUEST]({ commit }, {
    account,
    cluster,
    resultsPerPage = 10,
    pageNumber = 1,
    filterString = '',
  }) {
    try {
      commit(API_ACCOUNT_CLUSTER_PROPERTIES.REQUEST);

      const { data } = await apiClient.request({
        method: 'GET',
        url: ApiAccountClusterProperties,
        pathParams: {
          id: account.id,
          cluster,
        },
        params: {
          per_page: resultsPerPage,
          page_num: pageNumber,
          filters: [
            {
              field: 'name',
              operator: 'like',
              value: filterString,
            },
          ],
        },
      });
      if (!data) {
        throw new Error('no data returned');
      }

      commit(API_ACCOUNT_CLUSTER_PROPERTIES.SUCCESS, data);
    } catch (error) {
      commit(API_ACCOUNT_CLUSTER_PROPERTIES.ERROR, error);
    }
  },
  async [API_ACCOUNT_CLUSTER_CREATE.REQUEST]({ commit }, { account, name, propertyIds }) {
    try {
      commit(API_ACCOUNT_CLUSTER_CREATE.REQUEST);

      const { data } = await apiClient.request({
        method: 'POST',
        url: ApiAccountClusterCreate,
        pathParams: {
          id: account,
        },
        data: {
          name,
          property_ids: propertyIds,
        },
      });

      if (!data) {
        throw new Error('no data returned');
      }

      const { cluster_id: clusterId } = data;

      commit(API_ACCOUNT_CLUSTER_CREATE.SUCCESS, clusterId);
    } catch (error) {
      commit(API_ACCOUNT_CLUSTER_CREATE.ERROR, error);
    }
  },
  async [API_ACCOUNT_BRAND_CREATE.REQUEST]({ commit }, { account, name, propertyIds }) {
    try {
      commit(API_ACCOUNT_BRAND_CREATE.REQUEST);

      const { data } = await apiClient.request({
        method: 'POST',
        url: ApiAccountBrandCreate,
        pathParams: {
          id: account,
        },
        data: {
          name,
          property_ids: propertyIds,
        },
      });

      if (!data) {
        throw new Error('no data returned');
      }

      const { cluster_id: clusterId } = data;

      commit(API_ACCOUNT_BRAND_CREATE.SUCCESS, clusterId);
    } catch (error) {
      commit(API_ACCOUNT_BRAND_CREATE.ERROR, error);
    }
  },
  async [API_ACCOUNT_CLUSTER_UPDATE.REQUEST]({ commit }, {
    account,
    cluster,
    name,
    logo,
    color,
  }) {
    try {
      commit(API_ACCOUNT_CLUSTER_UPDATE.REQUEST);

      const { data } = await apiClient.request({
        method: 'PUT',
        url: ApiAccountClusterUpdate,
        pathParams: {
          id: account.id,
          cluster,
        },
        data: {
          name,
          logo_64: logo,
          color: color?.replace('#', ''),
        },
      });

      if (!data) {
        throw new Error('no data returned');
      }

      commit(API_ACCOUNT_CLUSTER_UPDATE.SUCCESS, data.data);
    } catch (error) {
      commit(API_ACCOUNT_CLUSTER_UPDATE.ERROR, error);
    }
  },
  async [API_ACCOUNT_CLUSTER_PROPERTY_ADD.REQUEST]({ commit }, {
    account,
    cluster,
    property,
  }) {
    try {
      commit(API_ACCOUNT_CLUSTER_UPDATE.REQUEST);

      await apiClient.request({
        method: 'POST',
        url: ApiAccountClusterPropertyAdd,
        pathParams: {
          id: account.id,
          cluster,
        },
        data: {
          property_id: property,
        },
      });

      commit(API_ACCOUNT_CLUSTER_PROPERTY_ADD.SUCCESS, property);
    } catch (error) {
      commit(API_ACCOUNT_CLUSTER.ERROR, error);
    }
  },
  async [API_ACCOUNT_CLUSTER_REMOVE.REQUEST]({ commit }, { account, cluster }) {
    try {
      commit(API_ACCOUNT_CLUSTER_REMOVE.REQUEST);

      await apiClient.request({
        method: 'DELETE',
        url: ApiAccountClusterDelete,
        pathParams: {
          account: account.id,
          id: cluster,
        },
      });

      commit(API_ACCOUNT_CLUSTER_REMOVE.SUCCESS);
    } catch (error) {
      commit(API_ACCOUNT_CLUSTER_REMOVE.ERROR, error);
    }
  },
  async [API_ACCOUNT_CLUSTER_PROPERTY_DELETE.REQUEST]({ commit }, {
    account,
    cluster,
    property,
  }) {
    try {
      commit(API_ACCOUNT_CLUSTER_UPDATE.REQUEST);

      await apiClient.request({
        method: 'POST',
        url: ApiAccountClusterPropertyDelete,
        pathParams: {
          id: account.id,
          cluster,
        },
        data: {
          property_id: property,
        },
      });

      commit(API_ACCOUNT_CLUSTER_PROPERTY_DELETE.SUCCESS, property);
    } catch (error) {
      commit(API_ACCOUNT_CLUSTER.ERROR, error);
    }
  },
  async [API_ACCOUNT_CLUSTER_PROPERTY_TRANSFER.REQUEST]({ commit }, {
    account,
    property,
    destination,
  }) {
    try {
      commit(API_ACCOUNT_CLUSTER_PROPERTY_TRANSFER.REQUEST);

      await apiClient.request({
        method: 'POST',
        url: ApiAccountClusterPropertyTransfer,
        pathParams: {
          id: account.id,
          property,
        },
        data: {
          brand_id: destination,
        },
      });

      commit(API_ACCOUNT_CLUSTER_PROPERTY_TRANSFER.SUCCESS);
    } catch (error) {
      commit(API_ACCOUNT_CLUSTER_PROPERTY_TRANSFER.ERROR, error);
      throw error;
    }
  },
  async [API_ACCOUNT_PROPERTIES.REQUEST]({ commit }, {
    account,
    resultsPerPage = 10,
    pageNumber = 1,
  }) {
    try {
      commit(API_ACCOUNT_PROPERTIES.REQUEST);

      const { team_member_id: teamMemberId } = account;

      const { data } = await apiClient.request({
        method: 'GET',
        url: ApiAccountProperties,
        pathParams: {
          id: account.id,
          teamMemberId,
        },
        params: {
          per_page: resultsPerPage,
          page_num: pageNumber,
        },
      });
      if (!data) {
        throw new Error('no data returned');
      }

      commit(API_ACCOUNT_PROPERTIES.SUCCESS, data);
    } catch (error) {
      commit(API_ACCOUNT_PROPERTIES.ERROR, error);
    }
  },
};

const clustersModule = {
  state,
  getters,
  mutations,
  actions,
};

buildApiRequest({
  storeModule: clustersModule,
  actionTypes: API_GET_ACCOUNT_PROPERTIES_NOBRAND,
  apiRoute: ApiAccountClusterPropertiesNoBrand,
});

export default clustersModule;
